/**
 * Card surfaces (elevated containers).
 * @see atomicRules.ts
 */
import { ViewStyle } from 'react-native';
import { appTheme } from '../appTheme';

export const cardBase: ViewStyle = {
  backgroundColor: appTheme.colors.surface,
  borderRadius: appTheme.borderRadius.md,
  padding: appTheme.spacing.md,
  ...appTheme.shadows.card,
};
